export const loadScript = ({ async = true, src, timeoutMs }: { async?: boolean; src: string; timeoutMs?: number }) =>
    new Promise<HTMLScriptElement>((resolve, reject) => {
        const timerId =
            timeoutMs &&
            setTimeout(() => {
                reject(new Error(`Load script timeout: ${src}`))
            }, timeoutMs)

        let script = Array.from(document.scripts).find((scriptElement) => scriptElement.src === src)

        const onLoad = () => {
            script!.dataset.state = 'loaded'

            resolve(script!)

            clearTimeout(timerId)
        }

        const onError = (errorEvent: ErrorEvent) => {
            script!.dataset.state = 'error'

            reject(new Error('Failed to load script', { cause: errorEvent }))

            clearTimeout(timerId)
        }

        if (script) {
            switch (script.dataset.state) {
                case 'loaded': {
                    onLoad()

                    return
                }
                case 'error': {
                    onError(new ErrorEvent(`Script ${src} has failed state`))

                    return
                }
                default: {
                    script.addEventListener('load', onLoad)
                    script.addEventListener('error', onError)
                }
            }

            return
        }

        script = document.createElement('script')

        script.src = src

        script.dataset.state = 'loading'

        if (async) {
            script.async = async
        }

        script.addEventListener('load', onLoad)
        script.addEventListener('error', onError)

        document.body.appendChild(script)
    })
